import ExcelJS from "exceljs";

export default function downloadExcel(data) {
  // return;
  // Sample data (replace this with your actual data)
  // const data = [
  //   {
  //     name: "John",
  //     age: 30,
  //     email: "john@example.com",
  //     num1: "10",
  //     num2: "20",
  //   },
  //   {
  //     name: "Jane",
  //     age: 25,
  //     email: "jane@example.com",
  //     num1: "130",
  //     num2: "20",
  //   },
  //   {
  //     name: "Mike",
  //     age: 35,
  //     email: "mike@example.com",
  //     num1: "10",
  //     num2: "50",
  //   },
  //   // Add more data rows as needed
  // ];

  const workbook = new ExcelJS.Workbook();
  const sheet = workbook.addWorksheet("Sheet1");

  // Set column widths
  sheet.getColumn("A").width = 20;
  sheet.getColumn("B").width = 17;
  sheet.getColumn("C").width = 17;
  sheet.getColumn("D").width = 17;
  sheet.getColumn("E").width = 23;
  sheet.getColumn("F").width = 17;
  sheet.getColumn("G").width = 17;
  sheet.getColumn("H").width = 17;
  sheet.getColumn("I").width = 17;
  sheet.getColumn("J").width = 17;
  sheet.getColumn("K").width = 17;
  sheet.getColumn("L").width = 17;
  sheet.getColumn("M").width = 17;
  sheet.getColumn("N").width = 17;

  // Set header height
  sheet.getRow(1).height = 30;
  sheet.getRow(2).height = 20;
  sheet.getRow(2).font = { bold: true };
  sheet.getRow(2).alignment = { horizontal: "center" };

  // Set title background color
  sheet.getCell("A1").fill = {
    pattern: "solid",
    fgColor: { argb: "FFF" }, // Gray color
  };

  sheet.getCell("A1").style = {
    alignment: { horizontal: "center" },
    font: { bold: true, size: 16 },
  };
  // Set title value with merged cells
  sheet.mergeCells("A1:N1");
  sheet.getCell("A1").value = "VISA Report"; // Change the main title text

  // Set header values
  sheet.getCell("A2").value = "Project";
  sheet.getCell("B2").value = "VRF No.";
  sheet.getCell("C2").value = "Status";
  sheet.getCell("D2").value = "Authorized Date";
  sheet.getCell("E2").value = "VISA Provider";
  sheet.getCell("F2").value = "Country";
  sheet.getCell("G2").value = "Job Position";
  sheet.getCell("H2").value = "VISA Profession";
  sheet.getCell("I2").value = "Total VISA";
  sheet.getCell("J2").value = "Total Candidates";
  sheet.getCell("K2").value = "VISA Stamped";
  sheet.getCell("L2").value = "Deployed";
  sheet.getCell("M2").value = "Yet to Deployed";
  sheet.getCell("N2").value = "Balance VISA";

  for (let i = 0; i < data.length; i++) {
    const row = sheet.getRow(i + 3);
    row.getCell("A").value = data[i].project?.name;
    row.getCell("B").value = data[i].vrf_no;
    row.getCell("C").value = data[i].status;
    row.getCell("D").value = data[i].authorized_date;
    row.getCell("E").value = data[i].company?.name;
    row.getCell("F").value = data[i].nationality?.name;
    row.getCell("G").value = data[i].job_position?.name;
    row.getCell("H").value = data[i].visa_profession?.name;
    row.getCell("I").value = data[i].visa_quantity;
    row.getCell("J").value = data[i].candidate?.length;
    row.getCell("K").value = data[i].candidate?.filter(
      (candidate) => candidate?.visa_stamped == "YES"
    )?.length;
    row.getCell("L").value = data[i].candidate?.filter(
      (candidate) => candidate?.visa_deployed == "YES"
    )?.length;
    row.getCell("M").value = data[i].candidate?.filter(
      (candidate) => candidate?.visa_deployed == "NO"
    )?.length;
    row.getCell("N").value =
      data[i]?.visa_quantity - data[i]?.candidate?.length;
  }

  // Generate the Excel file and initiate download
  workbook.xlsx.writeBuffer().then((buffer) => {
    const blob = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "VISA Report.xlsx";
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  });
}
